import { render, staticRenderFns } from "./responsiveHeader.vue?vue&type=template&id=65d7a3a2&scoped=true&"
import script from "./responsiveHeader.vue?vue&type=script&lang=js&"
export * from "./responsiveHeader.vue?vue&type=script&lang=js&"
import style0 from "./responsiveHeader.vue?vue&type=style&index=0&id=65d7a3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7a3a2",
  null
  
)

export default component.exports